import {Component, EventEmitter, Input, Output} from '@angular/core';
import {isNil} from "lodash-es";
import {ConfirmDialogService} from "../../confirm-dialog.service";

@Component({
    selector: 'app-address-suggestion-indicator',
    templateUrl: './address-suggestion-indicator.component.html',
    styleUrls: ['./address-suggestion-indicator.component.scss'],
    standalone: false
})
export class AddressSuggestionIndicatorComponent {

  constructor(
    private confirmDialogService: ConfirmDialogService,
  ) {
  }


  @Input() suggestedAddress: any;
  @Input() states: any;
  @Input() countries: any;

  @Output() suggestedAddressAccepted = new EventEmitter();

  @Input() id = 'address-suggestion';


  addressSuggestionExists() {
    return !isNil(this.suggestedAddress);
  }

  openAddressOverrideConfirmDialog() {
    this.confirmDialogService.openAddressOverrideConfirmDialog(
      this.suggestedAddress, this.states, this.countries)
      .subscribe(changeConfirmed => {
        if (changeConfirmed) {
          this.suggestedAddressAccepted.emit(this.suggestedAddress);
          this.suggestedAddress = null;
        }
      });
  }
}
